import React from 'react';
import './legal.css';

export function LegalLinks({ className = '' }) {
  return <nav className={`legal-links ${className}`} aria-label="Legal">
    <a href="/terms">Terms</a><a href="/privacy">Privacy</a><a href="/subprocessors">Subprocessors</a>
  </nav>;
}

export default function LegalLayout({ title, effectiveDate, children }) {
  return <div className="legal-page">
    <header className="legal-header"><a className="legal-brand" href="/">ManageLift</a><LegalLinks /></header>
    <main className="legal-document">
      <h1>{title}</h1>
      {effectiveDate ? <p><strong>Effective Date:</strong> {effectiveDate}</p> : null}
      {children}
    </main>
    <footer><LegalLinks /><p>© ManageLift LLC</p></footer>
  </div>;
}
